import { StateCreator } from 'zustand'
import { getRedirectUrl, Utils } from '../../utils'
import { BoundStore } from '../bound.store'
import { userPrefLoginMethod } from '../userPrefsState/userPrefsSignels'

interface VersionConfigState {
    passwordDefault: boolean
}
interface VersionConfigActions {
    initVersionConfig: () => void
}
export interface VersionConfigSlice
    extends VersionConfigState,
        VersionConfigActions {}

export const createVersionConfigSlice: StateCreator<
    BoundStore,
    [['zustand/devtools', never]],
    [],
    VersionConfigSlice
> = (set, get) => ({
    passwordDefault: false,
    initVersionConfig: async () => {
        const version = await Utils.getReactVersion()
        const url = getRedirectUrl(`releases/${version}/config.json`)
        try {
            const response = await fetch(url)
            const data = await response.json()
            console.log(data)
            if (data?.passwordDefault) {
                userPrefLoginMethod.value = 'password'
            }
            set({ passwordDefault: data.passwordDefault })
        } catch (error) {
            set({ passwordDefault: false })
        }
    },
})
